import Task from "../../../../../../shared/lib/html5-software-library/src/ranj/util/executor/Task";

export default class InitPlaySessionTask extends Task {

    constructor(playSessionModel) {
        super();

        this.execute = (callback, progressCallback) => {
            playSessionModel.startNewGameSession();
            //Task complete:
            callback(this);
        }
    }
}